import {DefaultMaskWMS, TethysAPIAppName} from "../config";
// import {Icon} from "ol/style";
import {Action} from "../store/actionType";
import {getURLParameters} from "./helpers";

// import {isEnglish} from "../utils/LanguageParameter";
//
// let IsEng=isEnglish();
var myApp = {};
// First need to initilize


myApp.startDate = new Date();
myApp.startDate = new Date(myApp.startDate.getTime() - (1 * 24 * 60 * 60 * 1000));
myApp.endDate = new Date();

let recentDate = getURLParameters()['date'];
if (recentDate) {
    if (recentDate.length == 8) {
        let checkInt = parseInt(recentDate);
        if (checkInt) {
            // Number with valid
            let YYYY = parseInt(recentDate.slice(0, 4));
            let MM_index = parseInt(recentDate.slice(4, 6)) - 1;
            let DD = parseInt(recentDate.slice(6, 8));
            let dObject = new Date(YYYY, MM_index, DD);
            myApp.startDate = dObject;
            myApp.endDate = new Date(myApp.startDate.getTime() + (1 * 24 * 60 * 60 * 1000));
        }
    }
}

myApp.IndexColors = ['#0C6CE9', '#962422', '#1D5430', '#F76743'];

myApp.APICollection = {
    layerData: {
        Aeronet: '/apps/' + TethysAPIAppName + '/aeronetaodpm/',
        USEmbassyAOD: '/apps/' + TethysAPIAppName + '/usembassypm/',
        getGeoJSONofStations: '/apps/' + TethysAPIAppName + '/getGeoJSONofStations/',
        getGeoJsonForOneSatation: '/apps/' + TethysAPIAppName + '/getGeoJsonForOneSatation/',
        getAllStationsID: '/apps/' + TethysAPIAppName + '/getAllStationsID/',
    },
    api: {
        commonAPI: '/apps/' + TethysAPIAppName + '/getData/',
        RegionGeojson: '/apps/' + TethysAPIAppName + '/geojsonregion/',
        AOIPolygon: '/apps/' + TethysAPIAppName + '/aoipolygon/',
        GetMapImage: '/apps/' + TethysAPIAppName + '/getmapimage/',
        GetImage: '/apps/' + TethysAPIAppName + '/downloadImage/',
        SlicedFromCatalog: '/apps/' + TethysAPIAppName + '/slicedfromcatalog/'
    }
};

myApp.constants = {
    recent: {
        layerId: {
            TerraModisTrueColor: 'Recent__TerraModisTrueColor',
            VIIRS_SNPPTrueColor: 'Recent__VIIRS_SNPP-TrueColor1km',
            PM_AeronetAOD: 'Recent__aeronet',
            PM_usembassy: 'Recent__usembassy',
            GEOS_PM2p5: 'Recent__GEOS_PM2p5',
            TerraModisAOD: 'Recent__TerraModisAOD',
            O3_GEOS: 'Recent__GEOS_O3',
            O3_usembassy: 'Recent__usembassy_O3',
            SO2_GEOS: 'Recent__GEOS_SO2',
            NO2_GEOS: 'Recent__GEOS_NO2',
            CO_GEOS: 'Recent__GEOS_CO',
            BT_PM10: 'BT_PM10',
            BT_PM2p5: 'BT_PM2p5',
            BT_O3: 'BT_O3',
            BT_SO2: 'BT_SO2',
            BT_NOx: 'BT_NOx',
            BT_CO: 'BT_CO',
            BT_BC: 'BT_BC',
        }
    }
};

myApp.IndexColors = ['#0C6CE9', '#962422', '#1D5430', '#F76743'];
myApp.AllBindedLayersList = [];
myApp.OnlyOnce = true;

myApp.getLayer = function (id) {
    // console.log(id)
    var layer;
    for (let i = 0; i < myApp.AllBindedLayersList.length; i++) {
        // console.log(myApp.AllBindedLayersList[i].getProperties().id);
        if (id == myApp.AllBindedLayersList[i].getProperties().id) { ///popDensityLayer.getProperties().id
            layer = myApp.AllBindedLayersList[i].getLayer();
            break;
        }
    }
    return layer;
};

myApp.formatDateWithHHMM = function (date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear(),
        hour = '' + d.getHours(),
        minute = '' + d.getMinutes()

    if (month.length < 2)
        month = '0' + month;

    if (day.length < 2)
        day = '0' + day;

    if (hour.length < 2)
        hour = '0' + hour

    if (minute.length < 2)
        minute = '0' + minute

    return [year, month, day, hour, minute].join('-');
};

myApp.formatDate = function (date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    return [year, month, day].join('-');
};

let SLDRGB = `<?xml version="1.0" encoding="ISO-8859-1"?>
<StyledLayerDescriptor version="1.1.0" xsi:schemaLocation="http://www.opengis.net/sldStyledLayerDescriptor.xsd"
                       xmlns="http://www.opengis.net/sld" xmlns:ogc="http://www.opengis.net/ogc"
                       xmlns:se="http://www.opengis.net/se" xmlns:xlink="http://www.w3.org/1999/xlink"
                       xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:resc="http://www.resc.reading.ac.uk">
    <NamedLayer>
     <se:Name>red</se:Name>
        <UserStyle>
            <se:Name>Thesholded colour scheme</se:Name>
            <se:CoverageStyle>
                <se:Rule>
                    <resc:RasterRGBSymbolizer>
                        <se:Opacity>1.0</se:Opacity>
                        <se:ColorMap>
                            <resc:RedBand>
                                <resc:BandName>red</resc:BandName>
                                <resc:Range>
                                    <resc:Minimum>0</resc:Minimum>
                                    <resc:Maximum>255</resc:Maximum>
                                </resc:Range>
                            </resc:RedBand>
                            <resc:GreenBand>
                                <resc:BandName>green</resc:BandName>
                                <resc:Range>
                                    <resc:Minimum>0</resc:Minimum>
                                    <resc:Maximum>255</resc:Maximum>
                                </resc:Range>
                            </resc:GreenBand>
                            <resc:BlueBand>
                                <resc:BandName>blue</resc:BandName>
                                <resc:Range>
                                    <resc:Minimum>1</resc:Minimum>
                                    <resc:Maximum>255</resc:Maximum>
                                    <resc:Spacing>linear</resc:Spacing>
                                </resc:Range>
                            </resc:BlueBand>
                        </se:ColorMap>
                    </resc:RasterRGBSymbolizer>
                </se:Rule>
            </se:CoverageStyle>
        </UserStyle>
    </NamedLayer>
</StyledLayerDescriptor>
`;

myApp.MODISTrueColorImage = {
    catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/TerraMODIS-TrueColor1km/catalog.xml',
    useSLD: true,
    isTimeDimensionLayer: true,
    SLD: SLDRGB,
    getStartDate: function () {
        return myApp.formatDate(myApp.startDate)
    },
    getEndDate: function () {
        return myApp.formatDate(myApp.startDate)
    },
    VisibleDivBind: true,
    threddLayerProp: {
        id: myApp.constants.recent.layerId.TerraModisTrueColor,
        title: 'TerraModis-TrueColor (' + myApp.formatDate(myApp.startDate) + ')',
        visible: false,
        opacity: 0.5,
        legendPath: Action.Base + '/' + Action.trueColorLegendImage,
        ThreddsDataServerVersion: 5,
        serverType: 'TDS',
        timeSeries: false,
        alignTimeSlider: 'left',
        timeSliderSize: 'small',
        showlegend: false,
        showControlPanel: false,
        zIndex: 10,
        source: {
            url: [],
            params: {
                'LAYERS': 'red',
                'transparent': true
            }
        },
        mask: DefaultMaskWMS,
        CropOrMask: 'crop',
        changeWMSProxy: true,
    }
};

myApp.TrueColorImage = {
    catalog: 'catalog/BTAirQualityWatch/RecentAndArchive/VIIRS_SNPP-TrueColor1km/catalog.xml',
    useSLD: true,
    isTimeDimensionLayer: true,
    SLD: SLDRGB,
    getStartDate: function () {
        return myApp.formatDate(myApp.startDate)
    },
    getEndDate: function () {
        return myApp.formatDate(myApp.startDate)
    },
    VisibleDivBind: true,
    threddLayerProp: {
        id: myApp.constants.recent.layerId.VIIRS_SNPPTrueColor,
        title: 'VIIRS SNPP TrueColor (' + myApp.formatDate(myApp.startDate) + ')',
        visible: true,
        opacity: 0.5,
        legendPath: Action.Base + '/' + Action.trueColorLegendImage,
        ThreddsDataServerVersion: 5,
        serverType: 'TDS',
        timeSeries: false,
        alignTimeSlider: 'left',
        timeSliderSize: 'small',
        showlegend: false,
        showControlPanel: false,
        zIndex: 1,
        source: {
            url: [],
            params: {
                'LAYERS': 'red',
                'transparent': true
            }
        },
        mask: DefaultMaskWMS,
        CropOrMask: 'crop',
        changeWMSProxy: true,
    }
};

myApp.DefaultSations = {
    aeronetAOD: [10, 11, 10, 11],
    pm2p5Embassy: [6, 7, 6, 7],
    o3Embassy: [6, 7, 6, 7],
    NepalStation: [13,9]
};
myApp.cascaderObj = [
    {
        label: 'PM',
        value: 1,
        children: [
            // {
            //     label: 'Surface Observation-AOD (AERONET)',
            //     value: 11,
            //     layerId: myApp.constants.recent.layerId.PM_AeronetAOD,
            //     stationData: true,
            //     ModelClass: 'AeronetAod',
            //     ModelClassDataList: 'AeronetDataList',
            //     typeName: 'aod',
            //     defaultStation: myApp.DefaultSations.aeronetAOD,
            //     chart: {
            //         title: function (stationName) {
            //             return 'AERONET AOD at ' + stationName + ' (' + 'Last 24 hours' + ')';
            //         },
            //         subTitle: 'AERONET level 1.5 data measured at 500nm',
            //         SeriesName: 'SeriesName',
            //         YaxisLabel: 'AOD (500nm)',
            //         XaxisLabel: function () {
            //             return 'Time (UTC)'
            //         },
            //         plotType: 'point'
            //     },
            //     layerProperties: {
            //         initilize: false,
            //         id: myApp.constants.recent.layerId.PM_AeronetAOD,
            //         title: 'Surface Observation-AOD (AERONET)',
            //         visible: false,
            //         opacity: 1,
            //         zIndex: 5,
            //         layer: 'AirQuality:aeronet_aod',
            //     },
            // },
            // {
            //     label: 'Ground Observation-PM2.5 (AirNow)',
            //     layerId: myApp.constants.recent.layerId.PM_usembassy,
            //     value: 12,
            //     stationData: true,
            //     NotificationWhenAdded: "Please Select US Embassy 2.5 Station on map",
            //     ModelClass: 'UsEmbassyPm',
            //     ModelClassDataList: 'UsEmbassyDataList',
            //     typeName: 'pm',
            //     defaultStation: myApp.DefaultSations.pm2p5Embassy,
            //     chart: {
            //         title: function (stationName) {
            //             return stationName + ' (' + 'Last 24 hours' + ')';
            //         },
            //         subTitle: 'source: AirNow',
            //         SeriesName: 'PM2.5',
            //         YaxisLabel: 'PM<sub>2.5</sub>(μg/m<sup>3</sup>)',
            //         XaxisLabel: function () {
            //             return 'Time (UTC)'
            //         }
            //     },
            //     layerProperties: {
            //         initilize: false,
            //         id: myApp.constants.recent.layerId.PM_usembassy,
            //         title: 'Ground Observation-PM2.5',
            //         visible: false,
            //         opacity: 1,
            //         zIndex: 6,
            //         layer: 'AirQuality:us_embassy_pm2p5',
            //     },
            // },
            // {
            //     label: 'Ground Observation-PM1',
            //     layerId: myApp.constants.recent.layerId.BT_Gov_PM1,
            //     value: 13,
            //     stationData: true,
            //     ModelClass: 'BangladeshAqStation',
            //     ModelClassDataList: 'ObservationStationsBangladeshDataList',
            //     typeName: 'PM1_I',
            //     defaultStation: myApp.DefaultSations.NepalStation,
            //     chart: {
            //         title: function (stationName) {
            //             return stationName + ' (' + 'Last 24 hours' + ')'
            //         },
            //         subTitle: 'source: ICIMOD',
            //         SeriesName: 'PM1',
            //         YaxisLabel: 'PM<sub>1</sub>(μg/m<sup>3</sup>)',
            //         XaxisLabel: function () {
            //             return 'Time (UTC)'
            //         }
            //     },
            //     layerProperties: {
            //         initilize: false,
            //         id: myApp.constants.recent.layerId.BT_Gov_PM1,
            //         title: 'Ground Observation-PM1',
            //         visible: false,
            //         opacity: 1,
            //         zIndex: 6,
            //         layer: 'AirQualityBT:bhutan_aq_stations',
            //     },
            // },
            {
                label: 'Ground Observation-PM2.5',
                layerId: myApp.constants.recent.layerId.BT_PM2p5,
                value: 11,
                stationData: true,
                ModelClass: 'ObservationStationsBhutan',
                ModelClassDataList: 'ObservationStationsBhutanDataList',
                typeName: 'pm2.5',
                defaultStation: myApp.DefaultSations.NepalStation,
                chart: {
                    title: function (stationName) {
                       
                        return stationName + ' (' + 'Last 24 hours' + ')';
                    },
                    subTitle: 'source: ICIMOD',
                    SeriesName: 'PM2.5',
                    YaxisLabel: 'PM<sub>2.5</sub>(μg/m<sup>3</sup>)',
                    XaxisLabel: function () {
                        return 'Time (UTC)'
                    }
                   
                },
                layerProperties: {
                    initilize: false,
                    id: myApp.constants.recent.layerId.BT_PM2p5,
                    title: 'Ground Observation-PM2.5',
                    visible: false,
                    opacity: 1,
                    zIndex: 6,
                    layer: 'AirQualityBT:bhutan_aq_stations',
                },
            },
            {
                label: 'Ground Observation-PM10',
                layerId: myApp.constants.recent.layerId.BT_PM10,
                value: 12,
                stationData: true,
                ModelClass: 'ObservationStationsBhutan',
                ModelClassDataList: 'ObservationStationsBhutanDataList',
                typeName: 'pm10',
                defaultStation: myApp.DefaultSations.NepalStation,
                chart: {
                    title: function (stationName) {
                        return stationName + ' (' + 'Last 24 hours' + ')';
                    },
                    subTitle: 'source: ICIMOD',
                    SeriesName: 'PM10',
                    YaxisLabel: 'PM<sub>10</sub>(μg/m<sup>3</sup>)',
                    XaxisLabel: function () {
                        return 'Time (UTC)'
                    }
                   
                },
                layerProperties: {
                    initilize: false,
                    id: myApp.constants.recent.layerId.BT_PM10,
                    title: 'Ground Observation-PM10',
                    visible: false,
                    opacity: 1,
                    zIndex: 6,
                    layer: 'AirQualityBT:bhutan_aq_stations',
                },
            },
            // {
            //     label: 'Ground Observation-TSP',
            //     layerId: myApp.constants.recent.layerId.BT_Gov_tsp,
            //     value: 16,
            //     stationData: true,
            //     ModelClass: 'BangladeshAqStation',
            //     ModelClassDataList: 'ObservationStationsBangladeshDataList',
            //     typeName: 'TSP_I',
            //     defaultStation: myApp.DefaultSations.NepalStation,
            //     chart: {
            //         title: function (stationName) {
            //             return stationName + ' (' + 'Last 24 hours' + ')'
            //         },
            //         subTitle: 'source: ICIMOD',
            //         SeriesName: 'TSP',
            //         YaxisLabel: 'TSP (μg/m<sup>3</sup>)',
            //         XaxisLabel: function () {
            //             return 'Time (UTC)'
            //         }
            //     },
            //     layerProperties: {
            //         initilize: false,
            //         id: myApp.constants.recent.layerId.BT_Gov_tsp,
            //         title: 'Ground Observation-TSP',
            //         visible: false,
            //         opacity: 1,
            //         zIndex: 6,
            //         layer: 'AirQualityBT:bhutan_aq_stations',
            //     },
            // },
        ]
    },
    {
        label: 'O3',
        value: 2,
        children: [
            {
                label: 'Ground Observation-O3',
                layerId: myApp.constants.recent.layerId.BT_PM2p5,
                value: 21,
                stationData: true,
                ModelClass: 'ObservationStationsBhutan',
                ModelClassDataList: 'ObservationStationsBhutanDataList',
                typeName: 'o3',
                defaultStation: myApp.DefaultSations.NepalStation,
                chart: {
                    title: function (stationName) {
                        return stationName + ' (' + 'Last 24 hours' + ')';
                    },
                    subTitle: 'source: ICIMOD',
                    SeriesName: 'O3',
                    YaxisLabel: 'O<sub>3</sub>',
                    XaxisLabel: function () {
                        return 'Time (UTC)'
                    }
                    
                },
                layerProperties: {
                    initilize: false,
                    id: myApp.constants.recent.layerId.BT_PM2p5,
                    title: 'Ground Observation-O3',
                    visible: false,
                    opacity: 1,
                    zIndex: 6,
                    layer: 'AirQualityBT:bhutan_aq_stations',
                },
            },
        ]
    }, {
        label: 'SO2',
        value: 3,
        children: [
            {
                label: 'Ground Observation-SO2',
                layerId: myApp.constants.recent.layerId.BT_SO2,
                value: 31,
                stationData: true,
                ModelClass: 'ObservationStationsBhutan',
                ModelClassDataList: 'ObservationStationsBhutanDataList',
                typeName: 'so2',
                defaultStation: myApp.DefaultSations.NepalStation,
                chart: {
                    title: function (stationName) {
                        return stationName + ' (' + 'Last 24 hours' + ')';
                    },
                    subTitle: 'source: ICIMOD',
                    SeriesName: 'so2',
                    YaxisLabel: 'PM<sub>2.5</sub>(μg/m<sup>3</sup>)',
                    XaxisLabel: function () {
                        return 'Time (UTC)'
                    }
                   
                },
                layerProperties: {
                    initilize: false,
                    id: myApp.constants.recent.layerId.BT_SO2,
                    title: 'Ground Observation-SO2',
                    visible: false,
                    opacity: 1,
                    zIndex: 6,
                    layer: 'AirQualityBT:bhutan_aq_stations',
                },
            },
        ]
    },
        {
        label: 'NOx',
        value: 4,
        children: [
            {
                label: 'Ground Observation-NOx',
                layerId: myApp.constants.recent.layerId.BT_NOx,
                value: 41,
                stationData: true,
                ModelClass: 'ObservationStationsBhutan',
                ModelClassDataList: 'ObservationStationsBhutanDataList',
                typeName: 'no2',
                defaultStation: myApp.DefaultSations.NepalStation,
                chart: {
                    title: function (stationName) {
                        return stationName + ' (' + 'Last 24 hours' + ')';
                    },
                    subTitle: 'source: ICIMOD',
                    SeriesName: 'so2',
                    YaxisLabel: 'PM<sub>2.5</sub>(μg/m<sup>3</sup>)',
                    XaxisLabel: function () {
                        return 'Time (UTC)'
                    }
                   
                },
                layerProperties: {
                    initilize: false,
                    id: myApp.constants.recent.layerId.BT_NOx,
                    title: 'Ground Observation-NO2',
                    visible: false,
                    opacity: 1,
                    zIndex: 6,
                    layer: 'AirQualityBT:bhutan_aq_stations',
                },
            },
        ]}, {
        label: 'CO',
        value: 5,
        children: [
                        {
                label: 'Ground Observation-CO',
                layerId: myApp.constants.recent.layerId.BT_CO,
                value: 51,
                stationData: true,
                ModelClass: 'ObservationStationsBhutan',
                ModelClassDataList: 'ObservationStationsBhutanDataList',
                typeName: 'co',
                defaultStation: myApp.DefaultSations.NepalStation,
                chart: {
                    title: function (stationName) {
                        return stationName + ' (' + 'Last 24 hours' + ')';
                    },
                    subTitle: 'source: ICIMOD',
                    SeriesName: 'co',
                    YaxisLabel: 'PM<sub>2.5</sub>(μg/m<sup>3</sup>)',
                    XaxisLabel: function () {
                        return 'Time (UTC)'
                    }
                   
                },
                layerProperties: {
                    initilize: false,
                    id: myApp.constants.recent.layerId.BT_CO,
                    title: 'Ground Observation-CO',
                    visible: false,
                    opacity: 1,
                    zIndex: 6,
                    layer: 'AirQualityBT:bhutan_aq_stations',
                },
            },
        ]}
        ,
        {
            label: 'BC',
            value: 6,
            children: [
                {
                    label: 'Ground Observation-BC',
                    layerId: myApp.constants.recent.layerId.BT_BC,
                    value: 61,
                    stationData: true,
                    ModelClass: 'ObservationStationsBhutan',
                    ModelClassDataList: 'ObservationStationsBhutanDataList',
                    typeName: 'bc',
                    defaultStation: myApp.DefaultSations.NepalStation,
                    chart: {
                        title: function (stationName) {
                            return stationName + ' (' + 'Last 24 hours' + ')';
                        },
                        subTitle: 'source: ICIMOD',
                        SeriesName: 'bc',
                        YaxisLabel: 'PM<sub>2.5</sub>(μg/m<sup>3</sup>)',
                        XaxisLabel: function () {
                            return 'Time (UTC)'
                        }
                       
                    },
                    layerProperties: {
                        initilize: false,
                        id: myApp.constants.recent.layerId.BT_BC,
                        title: 'Ground Observation-BC',
                        visible: false,
                        opacity: 1,
                        zIndex: 6,
                        layer: 'AirQualityBT:bhutan_aq_stations',
                    },
                },
            ]
        }
];

myApp.makeRequest = function (method, url) {
    return new Promise(function (resolve, reject) {
        let xhr = new XMLHttpRequest();
        xhr.open(method, url);
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                resolve(xhr.response);
            } else {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            }
        };
        xhr.onerror = function () {
            reject({
                status: this.status,
                statusText: xhr.statusText
            });
        };
        xhr.send();
    });
};

myApp.datetimePointChartObj = function (title, subTitle, SeriesData, SeriesName, YaxisLabel, XaxisLabel, plotColor, DataPeriod) {
    let data = {
        chart: {
            marginLeft: 65,
            /* marginRight: 0, */
            /* spacingLeft: 0, */
            /* spacingRight: 0 */
            backgroundColor: 'transparent',
            plotBorderColor: '#afafaf',
            plotBorderWidth: 1,
        },
        title: {
            text: title,
            fontSize: '10px',
            useHTML: true
        },
        subtitle: {
            text: subTitle,
            fontSize: '8px'
        },
        series: [{
            name: SeriesName,
            data: SeriesData,
            lineWidth: 0,
            marker: {
                enabled: true,
                symbol: 'diamond',
                radius: 2
            },
        }],
        xAxis: {
            type: 'datetime',
            title: {
                text: XaxisLabel,
                align: 'high',
            },
            tickLength: 0,
            lineColor: 0,
            lineWidth: 0
        },
        yAxis: {
            title: {
                text: `<span style="display:inline-block; -webkit-transform: rotate(270deg); -moz-transform: rotate(270deg); -ms-transform: rotate(270deg); -o-transform: rotate(270deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);">${YaxisLabel}</span>`,
                useHTML: true,
                rotation: 0,
                // align: 'high',
                offset: 0,
                x: -50
            },
            tickLength: 0,
            lineColor: 0,
            lineWidth: 0,
            gridLineWidth: 0
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            series: {
                color: plotColor
            }
        },
        lang: {
            noData: DataPeriod + 'data not available for this station.'
        },
        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ["printChart",
                        "separator",
                        "downloadPNG",
                        "downloadJPEG",
                        "downloadPDF",
                        "downloadSVG",
                        "separator",
                        "downloadCSV",
                        "downloadXLS",
                        //"viewData",
                        "openInCloud"]
                }
            },
            // chartOptions: {
            //     title: {
            //         text: title,
            //         fontSize: '10px',
            //         useHTML: true
            //     }, yAxis: {
            //         title: {
            //             text: `<span style="display:inline-block; -webkit-transform: rotate(90deg); -moz-transform: rotate(90deg); -ms-transform: rotate(90deg); -o-transform: rotate(90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);">${YaxisLabel}</span>`,
            //             useHTML: true,
            //             rotation: 250
            //         }
            //     },
            // },
            allowHTML: true,
            // fallbackToExportServer: false,
            // libURL: 'http://localhost:8000/static/airqualitywatch/js/Highcharts/lib/'
        }
    };
    return data
};

myApp.AQIBarChartObject = function (title, subTitle, SeriesData, SeriesName, YaxisLabel, XaxisLabel, plotColor, DataPeriod) {

    let seriesDataProcess = [{
        name: 'Good (0-50)',
        data: [],
        color: '#00e400'
    }, {
        name: 'Moderate (51-100)',
        data: [],
        color: '#ffff00'
    }, {
        name: 'Unhealthy for Sensitive Groups (101-150)',
        data: [],
        color: '#ff7e00'
    }, {
        name: 'Unhealthy (151-200)',
        data: [],
        color: '#ff0000'
    }, {
        name: 'Very Unhealthy (201-300)',
        data: [],
        color: '#8f3f97'
    }, {
        name: 'Hazardous (301-500)',
        data: [],
        color: '#7e0023'
    }];

    // 0	GOOD
    // 1	MODERATE
    // 2	CAUTION
    // 3	UNHEALTHY
    // 4	VERY UNHEALTHY
    // 5	EXTREMELY UNHEALTHY

    for (let kl of SeriesData) {
        if (kl[1] > 0 && kl[1] <= 50) {
            seriesDataProcess[0].data.push(kl)
        } else if (kl[1] >= 51 && kl[1] <= 100) {
            seriesDataProcess[1].data.push(kl)
        } else if (kl[1] >= 101 && kl[1] <= 150) {
            seriesDataProcess[2].data.push(kl)
        } else if (kl[1] >= 151 && kl[1] <= 200) {
            seriesDataProcess[3].data.push(kl)
        } else if (kl[1] >= 201 && kl[1] <= 300) {
            seriesDataProcess[4].data.push(kl)
        } else if (kl[1] >= 301) {
            seriesDataProcess[5].data.push(kl)
        }
    }

    seriesDataProcess.reverse()

    let data = {
        chart: {
            type: 'column',
            plotBorderWidth: 1,
        },
        title: {
            text: title,
            fontSize: '10px',
            useHTML: true
        },
        subtitle: {
            text: subTitle,
            fontSize: '8px'
        },
        xAxis: {
            type: 'datetime',
            title: {
                text: 'Date'
            }
        },
        lang: {
            noData: DataPeriod + 'data not available for this station.'
        },
        yAxis: {
            min: 0,
            title: {
                text: 'AQI'
            }
        },
        legend: {
            reversed: true
        },
        plotOptions: {
            series: {
                stacking: 'normal'
            }
        },
        credits: {
            enabled: false
        },
        series: seriesDataProcess,
        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ["printChart",
                        "separator",
                        "downloadPNG",
                        "downloadJPEG",
                        "downloadPDF",
                        "downloadSVG",
                        "separator",
                        "downloadCSV",
                        "downloadXLS",
                        //"viewData",
                        "openInCloud"]
                }
            },
            // chartOptions: {
            //     title: {
            //         text: title,
            //         fontSize: '10px',
            //         useHTML: true
            //     }, yAxis: {
            //         title: {
            //             text: `<span style="display:inline-block; -webkit-transform: rotate(90deg); -moz-transform: rotate(90deg); -ms-transform: rotate(90deg); -o-transform: rotate(90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);">${YaxisLabel}</span>`,
            //             useHTML: true,
            //             rotation: 250
            //         }
            //     },
            // },
            allowHTML: true,
            // fallbackToExportServer: false,
            // libURL: 'http://localhost:8000/static/airqualitywatch/js/Highcharts/lib/'
        }
    };

    return data

};

myApp.datetimeChartObj = function (title, subTitle, SeriesData, SeriesName, YaxisLabel, XaxisLabel, plotColor, DataPeriod) {
    let data = {
        chart: {
            marginLeft: 65,
            /* marginRight: 0, */
            /* spacingLeft: 0, */
            /* spacingRight: 0 */
            backgroundColor: 'transparent',
            plotBorderColor: '#afafaf',
            plotBorderWidth: 1,
        },
        title: {
            text: title,
            fontSize: '10px',
            useHTML: true
        },
        subtitle: {
            text: subTitle,
            fontSize: '8px'
        },
        series: [{
            name: SeriesName,
            data: SeriesData,
            // marker: {
            //     enabled: true,
            //     symbol: 'diamond',
            //     radius: 3
            // },
        }],
        xAxis: {
            type: 'datetime',
            title: {
                text: XaxisLabel,
                align: 'high',
            },
            tickLength: 0,
            lineColor: 0,
            lineWidth: 0
        },
        lang: {
            noData: DataPeriod + 'data not available for this station.'
        },
        yAxis: {
            title: {
                text: `<span style="display:inline-block; -webkit-transform: rotate(270deg); -moz-transform: rotate(270deg); -ms-transform: rotate(270deg); -o-transform: rotate(270deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);">${YaxisLabel}</span>`,
                useHTML: true,
                rotation: 0,
                // align: 'high',
                offset: 0,
                x: -50
            },
            tickLength: 0,
            lineColor: 0,
            lineWidth: 0,
            gridLineWidth: 0
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            series: {
                color: plotColor
            }
        },
        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ["printChart",
                        "separator",
                        "downloadPNG",
                        "downloadJPEG",
                        "downloadPDF",
                        "downloadSVG",
                        "separator",
                        "downloadCSV",
                        "downloadXLS",
                        //"viewData",
                        "openInCloud"]
                }
            },
            // chartOptions: {
            //     title: {
            //         text: title,
            //         fontSize: '10px',
            //         useHTML: true
            //     }, yAxis: {
            //         title: {
            //             text: `<span style="display:inline-block; -webkit-transform: rotate(90deg); -moz-transform: rotate(90deg); -ms-transform: rotate(90deg); -o-transform: rotate(90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);">${YaxisLabel}</span>`,
            //             useHTML: true,
            //             rotation: 250
            //         }
            //     },
            // },
            allowHTML: true,
            // fallbackToExportServer: false,
            // libURL: 'http://localhost:8000/static/airqualitywatch/js/Highcharts/lib/'
        }
    };
    return data
};

myApp.forceDownload = function (url, fileName) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function () {
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        var tag = document.createElement('a');
        tag.href = imageUrl;
        tag.download = fileName;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
    }
    xhr.send();
}


export var AirPollutionWatchApp = myApp;
